import { pubSub } from '@utils/PubSub';

export default class Humankind {
  constructor() {
    pubSub.subscribe('dy:humankindToggle:init', () => {
      this.show();
      pubSub.unsubscribe('dy:humankindToggle:init', this.show());
    });
  }
  show() {
    const toggle = window.Brooklinen?.humankind[0].toggle;
    const toggleModules = toggle.modules.split(',');
    const toggleFooterLink = toggle.footer_link;

    toggleModules.forEach((module) => {
      const moduleId = document.querySelector(`#${module.trim()}`);
      if (!module.includes('sidebar') || (moduleId && !sessionStorage.getItem('hideHKSidebar'))) {
        moduleId?.setAttribute('id', 'loaded-' + moduleId.getAttribute('id'));
      }
    });

    if (toggleFooterLink == 'True') {
      const footerLink = document.querySelector('footer [href="#/hk-entry-widget-open"]');
      if (footerLink) footerLink.style.display = 'initial';
    }

    const plp = window.Brooklinen?.humankind[0].plp;
    const sidebarContext = document.querySelector('.hk__sidebar')?.getAttribute('data-context');
    if (plp.sidebar_override == 'True' && sidebarContext == 'collection') {
      const moduleId = document.querySelector('.hk__sidebar')?.getAttribute('id');
      document.querySelector('.hk__sidebar').setAttribute('id', `loaded-${moduleId}`);
    }

    this.initCloseListeners();
  }

  initCloseListeners() {
    document.querySelector('.hk__sidebar .hk__close')?.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
      sessionStorage.setItem('hideHKSidebar', true);
      document.querySelector('.hk__sidebar').remove();
    });
  }
}
